import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { WORKSPACES_KEY } from "../api/hooks/useWorkspaces";

interface AcceptInviteResult {
  readonly workspaceId: string;
  readonly role: "owner" | "member" | "viewer";
  readonly alreadyMember: boolean;
}

export function useAcceptInvite(token: string) {
  const qc = useQueryClient();
  return useMutation<AcceptInviteResult, ApiError, void>({
    mutationFn: () =>
      apiFetch<AcceptInviteResult>(`/api/invites/${token}/accept`, { method: "POST" }),
    onSuccess: () => {
      // Refresh workspace list so the new workspace appears in the sidebar
      qc.invalidateQueries({ queryKey: WORKSPACES_KEY });
    },
  });
}
